// Mock data per suggerimenti AI - CRM Dashboard

export interface AIRecommendation {
  id: string
  title: string
  type: string
  diamondRange: string
  reason: string
  ctaLabel: string
  onCtaClick: () => void
}

// Suggerimenti generali dashboard
export const getGeneralRecommendations = (): Omit<
  AIRecommendation,
  'onCtaClick'
>[] => [
  {
    id: 'gen-1',
    title: 'Capitalizza il trend di crescita',
    type: 'Crescita',
    diamondRange: '+12.5% ultimo mese',
    reason:
      "Gli utenti attivi sono in crescita costante. Considera di lanciare una challenge speciale per consolidare l'engagement.",
    ctaLabel: 'Maggiori dettagli',
  },
  {
    id: 'gen-2',
    title: 'Ottimizza il processo di approvazione',
    type: 'Efficienza',
    diamondRange: '3 prove in attesa',
    reason:
      'Ci sono prove in attesa da oltre 4 ore. Una risposta più rapida migliora la soddisfazione degli utenti.',
    ctaLabel: 'Vedi prove',
  },
]

// Suggerimenti widget Utilizzo App
export const getAppUsageRecommendations = (): Omit<
  AIRecommendation,
  'onCtaClick'
>[] => [
  {
    id: 'app-1',
    title: 'Picco di utilizzo nel weekend',
    type: 'Engagement',
    diamondRange: '+15% Sab-Dom',
    reason:
      "Gli utenti sono più attivi nel weekend. Programma challenge e contenuti premium per sabato e domenica per massimizzare l'engagement.",
    ctaLabel: 'Pianifica contenuti',
  },
  {
    id: 'app-2',
    title: 'Calo mid-week da monitorare',
    type: 'Retention',
    diamondRange: '-8% Mer-Gio',
    reason:
      "Si nota un calo di utilizzo a metà settimana. Considera notifiche push mirate o micro-challenge quotidiane per mantenere l'engagement.",
    ctaLabel: 'Strategie retention',
  },
]

// Suggerimenti widget Punti Raccolti
export const getPointsRecommendations = (): Omit<
  AIRecommendation,
  'onCtaClick'
>[] => [
  {
    id: 'points-1',
    title: 'Economia punti in salute',
    type: 'Economia',
    diamondRange: 'Bilancio +18%',
    reason:
      'Il rapporto tra punti guadagnati e spesi è ottimale. Gli utenti accumulano e riscattano in modo equilibrato, segno di un sistema rewards efficace.',
    ctaLabel: 'Analisi dettagliata',
  },
  {
    id: 'points-2',
    title: 'Opportunità premium rewards',
    type: 'Monetizzazione',
    diamondRange: '22% utenti high-value',
    reason:
      'Il 22% degli utenti ha accumulato oltre 2000 punti diamante. Considera di introdurre premi premium esclusivi per incentivare i riscatti.',
    ctaLabel: 'Vedi catalogo premium',
  },
]

// Suggerimenti widget Top Users
export const getTopUsersRecommendations = (): Omit<
  AIRecommendation,
  'onCtaClick'
>[] => [
  {
    id: 'users-1',
    title: 'Riconosci i top contributor',
    type: 'Community',
    diamondRange: 'Top 5 utenti',
    reason:
      "I top 5 utenti generano il 35% dell'attività totale. Considera un programma ambassador o badge esclusivi per valorizzare il loro contributo.",
    ctaLabel: 'Programma ambassador',
  },
  {
    id: 'users-2',
    title: 'Rischio churn utenti medi',
    type: 'Retention',
    diamondRange: '15% utenti inattivi',
    reason:
      'Il 15% degli utenti precedentemente attivi non ha completato azioni negli ultimi 7 giorni. Campagna di re-engagement consigliata.',
    ctaLabel: 'Campagna re-engagement',
  },
]

// Suggerimenti widget Top Partners
export const getTopPartnersRecommendations = (): Omit<
  AIRecommendation,
  'onCtaClick'
>[] => [
  {
    id: 'partners-1',
    title: 'La Saponaria domina i riscatti',
    type: 'Partnership',
    diamondRange: '234 riscatti',
    reason:
      'La Saponaria genera il 28% dei riscatti totali. Considera di espandere il catalogo con prodotti simili o negoziare condizioni migliori.',
    ctaLabel: 'Analisi partnership',
  },
  {
    id: 'partners-2',
    title: 'Diversifica il portfolio partner',
    type: 'Strategia',
    diamondRange: 'Top 3 = 65%',
    reason:
      "I top 3 partner concentrano il 65% dei riscatti. Aumentare la varietà di partner riduce la dipendenza e migliora l'offerta.",
    ctaLabel: 'Nuovi partner',
  },
]

// Suggerimenti widget Prove in Attesa
export const getPendingProofsRecommendations = (): Omit<
  AIRecommendation,
  'onCtaClick'
>[] => [
  {
    id: 'proofs-1',
    title: 'Velocizza le approvazioni',
    type: 'Moderazione',
    diamondRange: 'Tempo medio: 4h',
    reason:
      "Il tempo medio di approvazione è di 4 ore. Riducendolo a 2 ore si migliora significativamente la soddisfazione utente e l'engagement.",
    ctaLabel: 'Ottimizza processo',
  },
  {
    id: 'proofs-2',
    title: 'Pattern di qualità foto',
    type: 'Qualità',
    diamondRange: '85% approvate',
    reason:
      "L'85% delle prove viene approvato al primo tentativo. Considera di creare una guida visiva per aiutare gli utenti a inviare foto di qualità.",
    ctaLabel: 'Crea guida',
  },
]
